import { createContext, useContext, type ReactNode } from 'react'
import type { FinancialEntry } from '@/modules/billing/entries/entriesTypes'
import { useBillingEntries } from '@/modules/billing/entries/useBillingEntries'

interface BillingContextType {
  entries: FinancialEntry[]
  loading: boolean
  error: string | null
  fetchEntries: (unitId: string, dateFrom: string, dateTo: string) => Promise<void>
  invalidateEntries: () => void
  refetchEntries: () => Promise<void>
}

const BillingContext = createContext<BillingContextType | undefined>(undefined)

export function BillingProvider({ children }: { children: ReactNode }) {
  const billingEntries = useBillingEntries()

  return (
    <BillingContext.Provider value={billingEntries}>
      {children}
    </BillingContext.Provider>
  )
}

export function useBilling() {
  const context = useContext(BillingContext)

  if (!context) {
    throw new Error('useBilling must be used within BillingProvider')
  }

  return context
}
